import { parseMissingEmailDebtCount, parseMissingPhoneDebtStats } from '../api/portfolioSyncStats';

export function PortfolioMissingPhoneAlert({
  stats,
}: {
  stats: Record<string, unknown> | null | undefined;
}) {
  const missingEmail = parseMissingEmailDebtCount(stats);
  const parsed = parseMissingPhoneDebtStats(stats);
  if (!parsed && missingEmail <= 0) {
    return null;
  }
  if (!parsed && missingEmail > 0) {
    return (
      <div className='rounded-xl border border-amber-300 bg-amber-50 p-4 text-sm dark:border-amber-800 dark:bg-amber-950/40'>
        <p className='text-3xl font-semibold text-amber-900 dark:text-amber-100'>{missingEmail}</p>
        <p className='font-medium text-amber-800 dark:text-amber-200'>con factura impaga y sin email en Setup</p>
        <p className='mt-1 text-amber-800/80 dark:text-amber-200/80'>
          No entran en campañas por email hasta cargar el correo en el maestro y volver a sincronizar.
        </p>
      </div>
    );
  }
  if (!parsed) {
    return null;
  }
  const extra = parsed.count - parsed.sample.length;
  return (
    <div className='rounded-xl border border-amber-300 bg-amber-50 p-4 text-sm dark:border-amber-800 dark:bg-amber-950/40'>
      <p className='text-3xl font-semibold text-amber-900 dark:text-amber-100'>{parsed.count}</p>
      <p className='font-medium text-amber-800 dark:text-amber-200'>con factura impaga y sin teléfono en Setup</p>
      <p className='mt-1 text-amber-800/80 dark:text-amber-200/80'>
        No aparecen en la lista de la izquierda. Hay que cargar el teléfono en el maestro de clientes y volver a
        sincronizar.
      </p>
      {parsed.sample.length > 0 ? (
        <ul className='mt-3 max-h-80 list-disc overflow-auto pl-5 text-amber-900 dark:text-amber-100'>
          {parsed.sample.map(row => (
            <li key={row.externalRef}>
              {row.name} <span className='text-amber-800/70 dark:text-amber-200/70'>(código {row.externalRef})</span>
            </li>
          ))}
        </ul>
      ) : null}
      {extra > 0 ? (
        <p className='mt-2 text-amber-800/80 dark:text-amber-200/80'>y {extra} más (no listados acá).</p>
      ) : null}
      {missingEmail > 0 ? (
        <p className='mt-3 text-amber-800/90 dark:text-amber-200/90'>
          Además, {missingEmail} con deuda y sin email en Setup (campañas por mail).
        </p>
      ) : null}
    </div>
  );
}
